<template>
    <ion-page>
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
          </ion-buttons>
          <ion-title>Cập nhật địa chỉ</ion-title>
          <ion-label slot="end" style="margin-right: 2vw"></ion-label>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-item>
            <ion-label color="medium" position="fixed">Quốc gia</ion-label>
            <ion-label class="p-fluid">
              <Dropdown v-model="selectedCountry" @change="onCountryChange($event)" :options="countries" optionLabel="country" optionValue="abbreviation" />
            </ion-label>
          </ion-item>

          <ion-item v-if="selectedCountry=='VN'">
            <ion-label color="medium" position="fixed">Tỉnh/TP</ion-label>
            <ion-label class="p-fluid">
              <Dropdown v-model="selectedProvince" @change="onProvinceChange($event)" :options="provinces" optionLabel="name" optionValue="id" />
            </ion-label>
          </ion-item>
          <ion-item v-else>
            <ion-label color="medium" position="fixed">Tỉnh/TP</ion-label>
            <ion-input v-model.trim="selectedProvince"></ion-input>
          </ion-item>


          <ion-item v-if="selectedCountry=='VN'">
            <ion-label color="medium" position="fixed">Quận/Huyện</ion-label>
            <ion-label class="p-fluid">
              <Dropdown v-model="selectedDistrict" @change="onDistrictChange($event)"  :options="districts" optionLabel="name" optionValue="id" />
            </ion-label>
          </ion-item>
          <ion-item v-else>
            <ion-label color="medium" position="fixed">Tỉnh/TP</ion-label>
            <ion-input v-model.trim="selectedDistrict"></ion-input>
          </ion-item>

          <ion-item v-if="selectedCountry=='VN'">
            <ion-label color="medium" position="fixed">Phường/Xã</ion-label>
            <ion-label class="p-fluid">
              <Dropdown v-model="selectedWard" :options="wards" optionLabel="name" optionValue="id" />
            </ion-label>
          </ion-item>
          <ion-item v-else>
            <ion-label color="medium" position="fixed">Tỉnh/TP</ion-label>
            <ion-input v-model.trim="selectedWard"></ion-input>
          </ion-item>

          <ion-item lines="none" class="ion-text-wrap">
            <ion-label color="medium">Số nhà, tên đường/Khu phố/Thôn/Ấp</ion-label>
          </ion-item>
          <ion-item>
            <ion-input v-model.trim="streetAddress" placeholder="123/4A đường số 9.."></ion-input>
          </ion-item>
        </ion-list>
        <div class="ion-padding">
          <ion-button expand="block" @click="saveAddress">LƯU ĐỊA CHỈ</ion-button>
        </div>
      </ion-content>
    </ion-page>
</template>

<style scoped>
  select {
    max-width: 100%;
    width: 100%;
    border: none;
    background: transparent;
  }
  .hidden {
    display: none;
  }
</style>

<script>
import Dropdown from 'primevue/dropdown/sfc';
import { defineComponent } from 'vue'
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
} from '@ionic/vue';
import { cloneDeep } from 'lodash';

export default defineComponent({
  name: 'EditAddress',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonLabel,
    IonList,
    IonItem,
    IonInput,
    IonButton,
    Dropdown,
  },
  data() {
    return {
      value: '',
      countries: [],
      provinces: [],
      districts: [],
      wards: [],
      streetAddress: '',
      selectedCountry: '',
      selectedProvince: '',
      selectedDistrict: '',
      selectedWard: '',

      selectedCity: null,
      cities: [
        {name: 'New York', code: 'NY'},
        {name: 'Rome', code: 'RM'},
        {name: 'London', code: 'LDN'},
        {name: 'Istanbul', code: 'IST'},
        {name: 'Paris', code: 'PRS'}
      ]
    }
  },
  methods: {
    async refresh() {
      const resp = await this.$utils.callAPI('GET', '/public/countries.json', {}, false);
      this.countries = resp.data;

      this.selectedCountry = String(this.$store.state.auth.address.country);
      this.selectedProvince = String(this.$store.state.auth.address.level1);
      this.selectedDistrict = String(this.$store.state.auth.address.level2);
      this.selectedWard = String(this.$store.state.auth.address.level3);
      this.streetAddress = String(this.$store.state.auth.address.street);
      console.log(this.selectedCountry);
      if (!this.selectedCountry) this.selectedCountry = 'VN';

      if (this.selectedCountry == 'VN') {
        await this.$utils.showLoading();

        await this.onCountryChange({
          value: 'VN'
        }, false);

        if (this.selectedProvince) await this.onProvinceChange({
          value: this.selectedProvince
        }, false);

        if (this.selectedDistrict) await this.onDistrictChange({
          value: this.selectedDistrict
        }, false);

        await this.$utils.hideLoading();
      }
    },
    async onCountryChange(event, loading = true) {
      console.log(event.value)
      // this.selectedCountry = event.value;
      this.provinces = [];
      this.districts = [];
      this.wards = [];
      if (event.value == 'VN') {
        if (loading) await this.$utils.showLoading();
        const resp = await this.$utils.callAPI('GET', '/public/administratives/level1.json', {}, false);
        this.provinces = cloneDeep(resp.data);
        console.log(this.provinces)
        if (loading) await this.$utils.hideLoading();
      }
    },
    async onProvinceChange(event, loading = true) {
      console.log(event.value)
      // this.selectedProvince = event.value;
      console.log(this.selectedCountry)
      this.districts = [];
      this.wards = [];
      if (this.selectedCountry == 'VN') {
        if (loading) await this.$utils.showLoading();
        const resp = await this.$utils.callAPI('GET', '/public/administratives/'+String(event.value)+'/level2.json', {}, false);
        this.districts = resp.data;
        if (loading) await this.$utils.hideLoading();
      }
    },
    async onDistrictChange(event, loading = true) {
      console.log(event.value)
      // this.selectedDistrict = event.value;
      this.wards = [];
      if (this.selectedCountry == 'VN') {
        if (loading) await this.$utils.showLoading();
        const resp = await this.$utils.callAPI('GET',
          '/public/administratives/'+String(this.selectedProvince)+'/'+String(event.value)+'/level3.json', {}, false);
        this.wards = resp.data;
        if (loading) await this.$utils.hideLoading();
      }
    },
    async saveAddress() {
      await this.$utils.showLoading();
      const address = {
        country: this.selectedCountry,
        street: this.streetAddress,
        level3: this.selectedWard,
        level2: this.selectedDistrict,
        level1: this.selectedProvince,
      };
      let addressParts = [];

      if (address.country != 'VN') {
        addressParts = [address.street, address.level3, address.level2, address.level1, address.country];
        addressParts = addressParts.filter(item => item);
      } else {
        addressParts = [
          address.street,
          this.wards.find( x => x.id == address.level3).name,
          this.districts.find( x => x.id == address.level2).name,
          this.provinces.find( x => x.id == address.level1).name,
        ];
        addressParts = addressParts.filter(item => item);
      }

      address.full = addressParts.join(', ');

      console.log(address);

      const resp = await this.$utils.callAPI(
        'POST', '/customers/address',
        address
      );
      console.log(resp);

      await this.$utils.hideLoading();

      if (resp.status == 200) {
        this.$store.commit('auth_update_info', {
          address: address,
        });
        (await this.$utils.toast("Lưu địa chỉ thành công", {
          position: "top",
          color: "success"
        })).present();
        this.$router.back();
      } else {
        if (resp.data && resp.data.message) {
          (await this.$utils.toast(resp.data.message, {position: "top"})).present();
        } else {
          (await this.$utils.toast("Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.", {position: "top"})).present();
        }
      }
    }
  },
  mounted() {
    this.refresh();
  },
  setup() {
    // TODO
  },
})
</script>
